import React from 'react';

import PageWrapper from './src/components/PageWrapper';
import RootProvider from './src/RootProvider';

export const wrapRootElement = ({element}) =>
  React.createElement(RootProvider, {element});

export const wrapPageElement = ({element, props}) =>
  React.createElement(PageWrapper, {element, props});
